// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  clear: both;
}

.action-btn,
.action-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: none;
  border: none;
  border-radius: 16px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:hover {
  background: var(--hover-bg);
  color: var(--primary-color);
}

.action-btn:disabled {
  opacity: 0.4;
  color: var(--text-secondary);
  cursor: default;
  pointer-events: none;
}

.action-link {
  text-decoration: none;
}

.action-link:hover {
  background: var(--hover-bg);
  color: var(--primary-color);
}

.action-btn svg,
.action-link svg {
  width: 18px;
  height: 18px;
}

.action-btn.like-btn:hover {
  background: var(--like-bg);
  color: var(--like-color);
}

.action-btn.like-btn.voted {
  color: var(--accent-primary);
}

.action-btn span.clickable {
  transition: opacity 0.2s, -webkit-text-decoration 0.2s;
  transition: opacity 0.2s, text-decoration 0.2s;
  transition: opacity 0.2s, text-decoration 0.2s, -webkit-text-decoration 0.2s;
}

.action-btn span.clickable:hover {
  opacity: 0.7;
  text-decoration: underline;
}

.action-btn.like-btn.voted svg {
  fill: var(--accent-primary);
  stroke: var(--accent-primary);
}

.action-btn.like-btn.voted:hover {
  background: var(--accent-primary-faded);
}

.downvote-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #7a8fa6;
  font-size: 13px;
  font-weight: 500;
  padding: 0 4px;
}

.downvote-indicator svg {
  width: 16px;
  height: 16px;
  stroke: #7a8fa6;
  flex-shrink: 0;
}

.downvote-indicator:hover {
  color: #5a7a99;
}

.downvote-indicator:hover svg {
  stroke: #5a7a99;
}

.action-btn.loading {
  opacity: 0.8;
  pointer-events: none;
  padding: 6px 12px;
  font-size: 13px;
}

.spinner-icon {
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
}

.loading-spinner {
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.like-btn-container {
  position: relative;
  display: inline-block;
}

/* dropdown menu for extra actions */
.action-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.action-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  border-radius: 8px;
  z-index: 100;
  min-width: 120px;
  padding: 4px 0;
}

.action-dropdown-menu .dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
}

.action-dropdown-menu .dropdown-item:hover {
  background: var(--hover-bg);
  color: var(--primary-color);
}

.action-dropdown-menu .dropdown-item.dropdown-item-disabled,
.action-dropdown-menu .dropdown-item.dropdown-item-disabled:hover {
  cursor: not-allowed;
  color: var(--text-tertiary);
  background: transparent;
  opacity: 0.8;
}

.copy-link-notice {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  padding: 6px 10px;
  border-radius: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  color: var(--text-primary);
  white-space: nowrap;
  z-index: 110;
}


.slider-header {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  text-align: center;
}

.slider-container {
  position: relative;
  padding-bottom: 32px;
  margin-bottom: 12px;
}

.vote-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: var(--border-color);
  outline: none;
  appearance: none;
  position: relative;
  z-index: 2;
}

.vote-slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.vote-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.slider-scale {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  height: 30px;
  pointer-events: none;
}

.scale-mark {
  position: absolute;
  transform: translateX(-50%);
  cursor: pointer;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.scale-mark:hover .scale-line {
  background: var(--primary-color);
}

.scale-mark:hover .scale-label {
  color: var(--primary-color);
  font-weight: 600;
}

.scale-mark.major .scale-line {
  width: 2px;
  height: 12px;
  background: var(--text-secondary);
  transition: all 0.2s;
}

.scale-mark.minor .scale-line {
  width: 1px;
  height: 6px;
  background: var(--text-tertiary);
  transition: all 0.2s;
}

.scale-label {
  margin-top: 4px;
  font-size: 11px;
  color: var(--text-secondary);
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s;
}

.slider-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.slider-actions.reflex-actions .confirm-btn {
  color: var(--bg-tertiary);
}

.cancel-btn,
.vote-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.vote-debug-info {
  padding: 12px;
  margin-top: 12px;
  background: var(--bg-tertiary, rgba(0, 0, 0, 0.05));
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
}

.vote-debug-info p {
  margin: 4px 0;
  color: var(--text-primary, #000);
  font-family: monospace;
}

.vote-debug-info strong {
  color: var(--accent-color, #1DA1F2);
  font-weight: 600;
  display: inline-block;
  min-width: 100px;
}

.cancel-btn {
  background: transparent;
  color: var(--text-secondary);
}

.cancel-btn:hover {
  background: var(--hover-bg);
}

.vote-btn {
  background: var(--primary-color);
  color: white;
}

.vote-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.vote-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Reply Box */
.reply-box {
  margin-top: 12px;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-color);
}

.reply-textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text-primary);
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  margin-bottom: 8px;
}

.reply-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.reply-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.char-count {
  font-size: 12px;
  color: var(--text-secondary);
}

.reply-meta-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.reply-buttons {
  display: flex;
  gap: 8px;
}

.cancel-reply-btn,
.preview-reply-btn,
.submit-reply-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-reply-btn {
  background: transparent;
  color: var(--text-secondary);
}

.cancel-reply-btn:hover {
  background: var(--hover-bg);
}

.preview-reply-btn {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.preview-reply-btn:hover:not(:disabled) {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.submit-reply-btn {
  background: var(--primary-color);
  color: white;
}

.submit-reply-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.submit-reply-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.preview-reply-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Comments Section */
.inline-comments-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.comments-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: 12px;
}

.loading-dots {
  display: flex;
  gap: 8px;
}

.loading-dots .dot {
  width: 8px;
  height: 8px;
  background: var(--primary-color);
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% { 
    transform: scale(0);
  }
  40% { 
    transform: scale(1.0);
  }
}

.comments-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.comments-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.view-all-link {
  font-size: 13px;
  color: var(--primary-color);
  text-decoration: none;
}

.view-all-link:hover {
  text-decoration: underline;
}

.no-comments {
  padding: 16px;
  text-align: center;
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

.inline-comments-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Feed Selector Modal */
.post-card .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.post-card .modal-content {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.feed-selector-modal {
  max-width: 720px !important;
  max-height: 95vh !important;
}

.feed-selector-modal h3 {
  margin: 0 0 20px 0;
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 600;
}

.feed-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.reblog-commentary-label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 600;
}

.reblog-commentary-input {
  width: 100%;
  min-height: 96px;
  resize: vertical;
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  font-family: inherit;
}

.reblog-commentary-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.confirm-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  background: var(--primary-color);
  color: white;
}

.confirm-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.feed-option-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 15px;
  color: var(--text-primary);
}

.feed-option-btn:hover {
  background: var(--hover-bg);
  border-color: var(--primary-color);
  transform: translateY(-1px);
}

.feed-option-btn.current-feed {
  background: rgba(29, 155, 240, 0.1);
  border-color: var(--primary-color);
  border-width: 2px;
}

.feed-icon {
  font-size: 20px;
}

.feed-name {
  font-weight: 500;
  flex: 1 1;
}

.current-badge {
  font-size: 11px;
  font-weight: 600;
  color: var(--primary-color);
  background: rgba(29, 155, 240, 0.15);
  padding: 3px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.rsm {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  margin-left:auto;
}

.action-btn.reward-btn {
  margin-left: auto;
  color: var(--primary-color);
  font-weight: 500;
}

.action-btn.reward-btn:hover {
  background: rgba(0, 100, 200, 0.1);
  color: var(--accent-primary);
}

.action-btn.reward-btn span {
  font-weight: 600;
  font-size: 12px;
}

/* Tippy Reward Tooltip Styling */
.reward-tooltip {
  background-color: var(--bg-primary);
  text-align: center;
  font-size: 13px;
  padding: 20px 26px;
  line-height: 1;
}

.reward-tooltip .strong {
  display: block;
}

.reward-tooltip .strong .reward-display {
  font-size: 11px;
  color: var(--text-secondary);
  margin-top:3px;
  vertical-align: bottom;
  line-height: 14px;
}

.reward-tooltip .reward-value {
  display: block;
  font-weight: 600;
  color: var(--accent-primary);
}

/* Tippy light theme customization */
.tippy-box[data-theme='light'] {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.tippy-box[data-theme='light'][data-placement^='top'] > .tippy-arrow::before {
  border-top-color: var(--bg-secondary);
}

.tippy-box[data-theme='light'][data-placement^='bottom'] > .tippy-arrow::before {
  border-bottom-color: var(--bg-secondary);
}

@media (max-width: 768px) {
  .action-btn {
    padding: 4px 8px;
    font-size: 0.85rem;
  }

  .action-btn svg {
    width: 16px;
    height: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PostActions/PostActions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sDAA8C;EAA9C,8CAA8C;EAA9C,4EAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EAEb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".post-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  clear: both;\n}\n\n.action-btn,\n.action-link {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: none;\n  border: none;\n  border-radius: 16px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-btn:hover {\n  background: var(--hover-bg);\n  color: var(--primary-color);\n}\n\n.action-btn:disabled {\n  opacity: 0.4;\n  color: var(--text-secondary);\n  cursor: default;\n  pointer-events: none;\n}\n\n.action-link {\n  text-decoration: none;\n}\n\n.action-link:hover {\n  background: var(--hover-bg);\n  color: var(--primary-color);\n}\n\n.action-btn svg,\n.action-link svg {\n  width: 18px;\n  height: 18px;\n}\n\n.action-btn.like-btn:hover {\n  background: var(--like-bg);\n  color: var(--like-color);\n}\n\n.action-btn.like-btn.voted {\n  color: var(--accent-primary);\n}\n\n.action-btn span.clickable {\n  transition: opacity 0.2s, text-decoration 0.2s;\n}\n\n.action-btn span.clickable:hover {\n  opacity: 0.7;\n  text-decoration: underline;\n}\n\n.action-btn.like-btn.voted svg {\n  fill: var(--accent-primary);\n  stroke: var(--accent-primary);\n}\n\n.action-btn.like-btn.voted:hover {\n  background: var(--accent-primary-faded);\n}\n\n.downvote-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #7a8fa6;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 0 4px;\n}\n\n.downvote-indicator svg {\n  width: 16px;\n  height: 16px;\n  stroke: #7a8fa6;\n  flex-shrink: 0;\n}\n\n.downvote-indicator:hover {\n  color: #5a7a99;\n}\n\n.downvote-indicator:hover svg {\n  stroke: #5a7a99;\n}\n\n.action-btn.loading {\n  opacity: 0.8;\n  pointer-events: none;\n  padding: 6px 12px;\n  font-size: 13px;\n}\n\n.spinner-icon {\n  width: 18px;\n  height: 18px;\n  animation: spin 1s linear infinite;\n}\n\n.loading-spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.like-btn-container {\n  position: relative;\n  display: inline-block;\n}\n\n/* dropdown menu for extra actions */\n.action-dropdown-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.action-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n  border-radius: 8px;\n  z-index: 100;\n  min-width: 120px;\n  padding: 4px 0;\n}\n\n.action-dropdown-menu .dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  color: var(--text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.action-dropdown-menu .dropdown-item:hover {\n  background: var(--hover-bg);\n  color: var(--primary-color);\n}\n\n.action-dropdown-menu .dropdown-item.dropdown-item-disabled,\n.action-dropdown-menu .dropdown-item.dropdown-item-disabled:hover {\n  cursor: not-allowed;\n  color: var(--text-tertiary);\n  background: transparent;\n  opacity: 0.8;\n}\n\n.copy-link-notice {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  color: var(--text-primary);\n  white-space: nowrap;\n  z-index: 110;\n}\n\n\n.slider-header {\n  margin-bottom: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  text-align: center;\n}\n\n.slider-container {\n  position: relative;\n  padding-bottom: 32px;\n  margin-bottom: 12px;\n}\n\n.vote-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: var(--border-color);\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  position: relative;\n  z-index: 2;\n}\n\n.vote-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--primary-color);\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.vote-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--primary-color);\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.slider-scale {\n  position: absolute;\n  top: 8px;\n  left: 0;\n  right: 0;\n  height: 30px;\n  pointer-events: none;\n}\n\n.scale-mark {\n  position: absolute;\n  transform: translateX(-50%);\n  cursor: pointer;\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.scale-mark:hover .scale-line {\n  background: var(--primary-color);\n}\n\n.scale-mark:hover .scale-label {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.scale-mark.major .scale-line {\n  width: 2px;\n  height: 12px;\n  background: var(--text-secondary);\n  transition: all 0.2s;\n}\n\n.scale-mark.minor .scale-line {\n  width: 1px;\n  height: 6px;\n  background: var(--text-tertiary);\n  transition: all 0.2s;\n}\n\n.scale-label {\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--text-secondary);\n  user-select: none;\n  transition: all 0.2s;\n}\n\n.slider-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.slider-actions.reflex-actions .confirm-btn {\n  color: var(--bg-tertiary);\n}\n\n.cancel-btn,\n.vote-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.vote-debug-info {\n  padding: 12px;\n  margin-top: 12px;\n  background: var(--bg-tertiary, rgba(0, 0, 0, 0.05));\n  border: 1px solid var(--border-color, #e0e0e0);\n  border-radius: 8px;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.vote-debug-info p {\n  margin: 4px 0;\n  color: var(--text-primary, #000);\n  font-family: monospace;\n}\n\n.vote-debug-info strong {\n  color: var(--accent-color, #1DA1F2);\n  font-weight: 600;\n  display: inline-block;\n  min-width: 100px;\n}\n\n.cancel-btn {\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.cancel-btn:hover {\n  background: var(--hover-bg);\n}\n\n.vote-btn {\n  background: var(--primary-color);\n  color: white;\n}\n\n.vote-btn:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n\n.vote-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Reply Box */\n.reply-box {\n  margin-top: 12px;\n  padding: 12px;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n}\n\n.reply-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--card-bg);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  margin-bottom: 8px;\n}\n\n.reply-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.reply-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.char-count {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.reply-meta-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.reply-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.cancel-reply-btn,\n.preview-reply-btn,\n.submit-reply-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancel-reply-btn {\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.cancel-reply-btn:hover {\n  background: var(--hover-bg);\n}\n\n.preview-reply-btn {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.preview-reply-btn:hover:not(:disabled) {\n  background: var(--hover-bg);\n  color: var(--text-primary);\n}\n\n.submit-reply-btn {\n  background: var(--primary-color);\n  color: white;\n}\n\n.submit-reply-btn:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n\n.submit-reply-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.preview-reply-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Comments Section */\n.inline-comments-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-color);\n}\n\n.comments-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  gap: 12px;\n}\n\n.loading-dots {\n  display: flex;\n  gap: 8px;\n}\n\n.loading-dots .dot {\n  width: 8px;\n  height: 8px;\n  background: var(--primary-color);\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.loading-dots .dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.loading-dots .dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% { \n    transform: scale(0);\n  }\n  40% { \n    transform: scale(1.0);\n  }\n}\n\n.comments-loading p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.comments-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.comments-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.view-all-link {\n  font-size: 13px;\n  color: var(--primary-color);\n  text-decoration: none;\n}\n\n.view-all-link:hover {\n  text-decoration: underline;\n}\n\n.no-comments {\n  padding: 16px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.inline-comments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Feed Selector Modal */\n.post-card .modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.post-card .modal-content {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 24px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.feed-selector-modal {\n  max-width: 720px !important;\n  max-height: 95vh !important;\n}\n\n.feed-selector-modal h3 {\n  margin: 0 0 20px 0;\n  color: var(--text-primary);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.feed-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.reblog-commentary-label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.reblog-commentary-input {\n  width: 100%;\n  min-height: 96px;\n  resize: vertical;\n  margin-bottom: 16px;\n  padding: 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-family: inherit;\n}\n\n.reblog-commentary-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.confirm-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: var(--primary-color);\n  color: white;\n}\n\n.confirm-btn:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n\n.confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.feed-option-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 15px;\n  color: var(--text-primary);\n}\n\n.feed-option-btn:hover {\n  background: var(--hover-bg);\n  border-color: var(--primary-color);\n  transform: translateY(-1px);\n}\n\n.feed-option-btn.current-feed {\n  background: rgba(29, 155, 240, 0.1);\n  border-color: var(--primary-color);\n  border-width: 2px;\n}\n\n.feed-icon {\n  font-size: 20px;\n}\n\n.feed-name {\n  font-weight: 500;\n  flex: 1;\n}\n\n.current-badge {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--primary-color);\n  background: rgba(29, 155, 240, 0.15);\n  padding: 3px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.rsm {\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n  margin-left:auto;\n}\n\n.action-btn.reward-btn {\n  margin-left: auto;\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.action-btn.reward-btn:hover {\n  background: rgba(0, 100, 200, 0.1);\n  color: var(--accent-primary);\n}\n\n.action-btn.reward-btn span {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Tippy Reward Tooltip Styling */\n.reward-tooltip {\n  background-color: var(--bg-primary);\n  text-align: center;\n  font-size: 13px;\n  padding: 20px 26px;\n  line-height: 1;\n}\n\n.reward-tooltip .strong {\n  display: block;\n}\n\n.reward-tooltip .strong .reward-display {\n  font-size: 11px;\n  color: var(--text-secondary);\n  margin-top:3px;\n  vertical-align: bottom;\n  line-height: 14px;\n}\n\n.reward-tooltip .reward-value {\n  display: block;\n  font-weight: 600;\n  color: var(--accent-primary);\n}\n\n/* Tippy light theme customization */\n.tippy-box[data-theme='light'] {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.tippy-box[data-theme='light'][data-placement^='top'] > .tippy-arrow::before {\n  border-top-color: var(--bg-secondary);\n}\n\n.tippy-box[data-theme='light'][data-placement^='bottom'] > .tippy-arrow::before {\n  border-bottom-color: var(--bg-secondary);\n}\n\n@media (max-width: 768px) {\n  .action-btn {\n    padding: 4px 8px;\n    font-size: 0.85rem;\n  }\n\n  .action-btn svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
